/* eslint-disable */

<template>
    <div class="content-box">
        <div class="header-box">
            <img src="../assets/logo.jpg" alt="" style="margin-top: 50px">
            <div style="color: white;font-size: 25px;font-weight: 900;margin-top: 20px;margin-bottom: 30px;">Cozy Corner</div>
            <div class="header-text">Color Your Daily Life</div>
            <div class="download-btn">
                <a class="download-a" href="https://itunes.apple.com/us/app/id6483808161?mt=8">
                    Download
                </a>
            </div>
        </div>

        <div class="sub-title">Relax with Daily Color</div>
        <div class="sub-title2">There are so many coloring pages and new pictures be updated every day!</div>
        <div class="sub-title2">You can relax by painting art, with 🏞nature, ❤️love, 🌷florals, 🧘characters, 🏵mandalas and so on..</div>

        <div class="noticeListBox">
                <img class="item-img" src="../assets/1.jpg">
                <img class="item-img" src="../assets/2.jpg">
                <img class="item-img" src="../assets/3.jpg">
                <img class="item-img" src="../assets/4.jpg">
                <img class="item-img" src="../assets/5.jpg">
        </div>

        <div style="font-size: 13px;">Copyright By PEGATINA TECH LIMITED  Contact us jvjvnee@gmail.com.</div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                items:[
                    "@/assets/screen_1.webp",
                    "../assets/screen_2.webp",
                    "../assets/screen_3.webp",
                    "../assets/screen_5.webp",
                    "../assets/screen_6.webp",
                ],
            }
        },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import url("//unpkg.com/element-plus/lib/theme-chalk/index.css");

    .header-box {
        text-align: center;
        background-color: #000000;
    }

    .header-text {
        font-size: 25px;
        color: rgba(255, 255, 255, 0.9);
        font-weight: 700;

    }

    .download-btn {
        display: inline-block;
        text-align: center;
        background-color: white;
        width: 172px;
        height: 56px;
        margin: 30px 0 50px 0;
        border-radius: 28px;

    }

    .download-a {
        line-height: 56px;
        text-decoration: none;
        font-size: 17px;
        color: #2e5fff;
        font-weight: 700;
    }

    .download-btn:before {
        content: '';
        margin: -3px 8px 0 0;
        width: 14px;
        height: 17px;
        display: inline-block;
        background-image: url(../img/sprite.png);
        background-repeat: no-repeat;
        background-position: -216px 0;
        -webkit-background-size: 250px 200px;
        background-size: 250px 200px;
        vertical-align: middle;
    }
    .item-img{
        background-color: yellow;
        margin: 0 20px;
        display: inline-block;
        /*height: 300px;*/
        width: 200px;
    }

    .noticeListBox{
        margin: 50px 20px 50px 20px;
        width: 100%;
        height: 500px;
        overflow: scroll;
        white-space: nowrap;
    }
    .noticeListBox::-webkit-scrollbar {
        display: none;
    }
    .sub-title{
        font-size: 27px;
        font-weight: 900;
        color: #000;
        margin: 20px;
    }
    .sub-title2{
        font-size: 17px;
        color: #222;
    }


</style>
